export default __webpack_public_path__ + "static/image01-d64e34931df39e05969f75bdc1062396.jpg";